import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPublicAudience as GetPublicAudienceQuery,
    GetPublicAudienceVariables as GetPublicAudienceVariables,
    GetPublicAudience_audience as Audience,
} from 'nutshell-graphql-types';

import GET_PUBLIC_AUDIENCE from '../queries/get-public-audience.graphql';

export const useGetPublicAudience = (
    id?: string | null
): {
    audience: Audience | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetPublicAudienceQuery,
        GetPublicAudienceVariables
    >(GET_PUBLIC_AUDIENCE, {
        skip: !id,
        variables: {
            // @ts-expect-error
            id,
        },
        fetchPolicy: 'cache-first',
    });

    const audience = data ? data.audience : null;

    return {
        audience,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
